define('OutSystems/ClientRuntime/modules/PubSub/Publisher',["require", "exports", "../../Logger"], function (require, exports, Logger) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var NULL_ARGUMENT_HANDLER_ERROR_MESSAGE = "Argument 'handler' cannot be null or undefined";
    var Publisher = (function () {
        function Publisher(moduleName, context) {
            this.moduleName = moduleName;
            this.context = context;
            this.subscribers = [];
        }
        Publisher.prototype.subscribe = function (handler) {
            if (!handler) {
                throw new Error(NULL_ARGUMENT_HANDLER_ERROR_MESSAGE);
            }
            for (var i = 0; i < this.subscribers.length; i++) {
                if (this.subscribers[i] === handler) {
                    return false;
                }
            }
            this.subscribers.push(handler);
            Logger.trace(this.moduleName, "Subscribing handler for " + this.context);
            return true;
        };
        Publisher.prototype.unsubscribe = function (handler) {
            if (!handler) {
                throw new Error(NULL_ARGUMENT_HANDLER_ERROR_MESSAGE);
            }
            for (var i = 0; i < this.subscribers.length; i++) {
                if (this.subscribers[i] === handler) {
                    this.subscribers.splice(i, 1);
                    Logger.trace(this.moduleName, "Unsubscribing handler for " + this.context);
                    return true;
                }
            }
            return false;
        };
        Publisher.prototype.publish = function (message) {
            for (var _i = 0, _a = this.subscribers; _i < _a.length; _i++) {
                var handler = _a[_i];
                handler(message);
            }
            Logger.trace(this.moduleName, "Notifying subscribers for " + this.context);
        };
        return Publisher;
    }());
    exports.default = Publisher;
});
//# sourceMappingURL=Publisher.js.map;
